import * as React from "react";
import { cn } from "../utils";

export interface LogoProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels.
   * Overrides both width and height when provided.
   */
  size?: number | string;
}

const Logo = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ className, size, width, height, ...props }, ref) => {
    const id = React.useId();
    const clipId = `${id}-clip0`;
    const mask1Id = `${id}-mask1`;

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 110 110"
        width={size ?? width ?? "110"}
        height={size ?? height ?? "110"}
        fill="none"
        className={cn("shrink-0", className)}
        aria-hidden="true"
        focusable="false"
        {...props}
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M76.6433 45.8257L109.862 103.36H43.425L76.6433 45.8257Z"
            fill="currentColor"
          />

          <mask
            id={mask1Id}
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="-15"
            y="6"
            width="113"
            height="98"
          >
            <path
              d="M41.4215 6.3999H97.3459V103.262H-14.5029L41.4215 6.3999Z"
              fill="currentColor"
            />
          </mask>
          <g mask={`url(#${mask1Id})`}>
            <path
              d="M16.1506 103.312L-39.7738 6.44926L72.075 6.44926L16.1506 103.312Z"
              fill="currentColor"
            />
          </g>
        </g>

        <defs>
          <clipPath id={clipId}>
            <rect width="110" height="110" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

Logo.displayName = "Logo";

export { Logo };
export default Logo;
